var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isRelevant)?_c('i',{staticClass:"tm-tracks-fog"},_vm._l((_vm.rectangles),function(rect,i){return _c('i',{key:i,style:(_vm.$_getStyle(rect))})}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }